import {config} from "@/constants/config";
import type {TResponseRequest} from "@/interfaces/http.interface";
import httpRequest from "@/providers/http/request.http";
import {buildQueryUrl} from "@/providers/http/request.instance";
import type {Transaction, TransactionStatus, TransactionType} from "@/types/transaction.types";
import {type PaginatedResult, normalizePagination} from "@/utils/pagination";

interface TransactionsFilters {
  page?: number;
  limit?: number;
  search?: string;
  type?: TransactionType | "all";
  status?: TransactionStatus | "all";
  userId?: string;
  from?: string;
  to?: string;
}

export type TransactionsListResult = PaginatedResult<Transaction>;

export interface TransactionsStats {
  totalTransactions: number;
  totalVolumeUsd: number;
  successRate: number;
  pending: number;
  completed: number;
  failed: number;
}

export const getTransactionsService = async (
  filters: TransactionsFilters = {}
): Promise<TResponseRequest<TransactionsListResult>> => {
  const params: Record<string, unknown> = {
    page: filters.page,
    limit: filters.limit,
    search: filters.search,
    userId: filters.userId,
    from: filters.from,
    to: filters.to,
  };
  if (filters.type && filters.type !== "all") params.type = filters.type;
  if (filters.status && filters.status !== "all") params.status = filters.status;

  const raw = await httpRequest.get<Transaction[]>({
    url: buildQueryUrl(`${config.walletApiUrl}/bo/transactions`, params),
  });
  if (!raw.data || !raw.pagination) return {...raw, data: undefined};
  return {...raw, data: {items: raw.data, pagination: normalizePagination(raw.pagination)}};
};

export const getTransactionByIdService = async (id: string): Promise<TResponseRequest<Transaction>> => {
  return httpRequest.get<Transaction>({
    url: `${config.walletApiUrl}/bo/transactions/${encodeURIComponent(id)}`,
  });
};

export const getTransactionsStatsService = async (): Promise<TResponseRequest<TransactionsStats>> => {
  return httpRequest.get<TransactionsStats>({
    url: `${config.walletApiUrl}/bo/transactions/stats`,
  });
};
